// Add your custom JS here.
(function ($) {
    // Fade in effects
    AOS.init();

    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,
    });


    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
            $("#mobile-menu").addClass("hide");
        } else {
            $("#wrapper-navbar").removeClass("hide");
            $("#mobile-menu").removeClass("hide");
        }
        lastScrollTop = st;
    });

    //check if header is at top of page
    $(document).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $("#wrapper-navbar").addClass("off-top");
            $(".top-navbar").addClass("off-top");
            $(".breadcrumbs").addClass("off-top");
            $("#mobile-menu").addClass("off-top");
        }
        if ($(this).scrollTop() < 100) {
            $("#wrapper-navbar").removeClass("off-top");
            $(".top-navbar").removeClass("off-top");
            $(".breadcrumbs").removeClass("off-top");
            $("#mobile-menu").removeClass("off-top");
        }
    });

    $(".custom-maker").trigger();

    // Swiper example
    // var swiper = new Swiper(".carouselname-swiper", {
    //     slidesPerView: "auto",
    //     center: true,
    //     loop: false,
    //     pagination: {
    //         el: ".carouselname-pagination",
    //         clickable: true,
    //         renderBullet: function (index, className) {
    //             return '<span class="' + className + '"></span>';
    //         },
    //     },
    //     navigation: {
    //         nextEl: ".carouselname-next",
    //         prevEl: ".carouselname-prev",
    //     },
    //     breakpoints: {
    //         768: {
    //           spaceBetween: 500,
    //         },
    //         1024: {
    //           spaceBetween: 500,
    //         },
    //       },
    // });

    // faq toggle
    $(".faq li").on("click", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).children(".a").slideUp();
        } else {
            $(".a").slideUp();
            $(".faq li").removeClass("active");
            $(this).addClass("active");
            $(this).children(".a").slideDown();
        }
    });

    $(".faq-menu a").on("click", function () {
        $(".faq-menu a").removeClass("active");
        $(this).addClass("active");
    });

    //Assign location ID to field
    $(".postadres-field :checkbox").click(function () {
        var selectedValues = $("#gform_fields_10_3 :checkbox:checked")
            .map(function () {
                return this.value;
            })
            .get();

        $("#input_10_33").val(selectedValues.join(","));
    });

    $(".postadres-field input").change(function () {
        var c = $(".postadres-field input").filter(
            (i, s) => $(s)[0].checked > 0
        ).length;
        $("#input_10_42").val(c);
    });

    //Assign location ID to field
    $(".postadres-field :checkbox").click(function () {
        var selectedValues = $("#gform_fields_10_3 :checkbox:checked")
            .map(function () {
                return this.value;
            })
            .get();

        $("#input_10_33").val(selectedValues.join(","));
    });

    $(".postadres-field input").change(function () {
        var c = $(".postadres-field input").filter(
            (i, s) => $(s)[0].checked > 0
        ).length;
        $("#input_3_42").val(c);
    });

    //change dashboard title based on selection

    $(".sidebar-items .sidebar-item").on("click", function () {
        var value = $(this).html();
        $(".sidebar-item").removeClass("active");
        $(this).addClass("active");

        $("#user-dashboard-wrapper .top-wrapper .title h3").html(value);
    });

    $(".sidebar .sidebar-items span").click(function () {
        var dataName = $(this).data("name");

        $(".dashboard-results[data-name]").removeClass("active");
        $('.dashboard-results[data-name="' + dataName + '"]').addClass(
            "active"
        );
    });

    $(".gchoice_3_52_0").append($(".option-ondernemer"));
    $(".gchoice_3_52_1").append($(".option-particulier"));

    $("#input_3_52 input").on("click", function () {
        $("#input_3_52 .gchoice").removeClass("active");
        $(this).parent().addClass("active");
    });

    $(".gchoice_10_52_0").append($(".option-ondernemer"));
    $(".gchoice_10_52_1").append($(".option-particulier"));

    $("#input_10_52 input").on("click", function () {
        $("#input_10_52 .gchoice").removeClass("active");
        $(this).parent().addClass("active");
    });

    //copy to clipboard

    document.addEventListener("DOMContentLoaded", function () {
        var clickableLinks = document.querySelectorAll(".clickable-link");

        clickableLinks.forEach(function (link) {
            link.addEventListener("click", function (event) {
                event.preventDefault();
                // Voer hier je gewenste actie uit
            });
        });
    });

    $(".copy-to-clipboard").on("click", function (e) {
        e.preventDefault(); // Voorkom standaard gedrag van de hyperlink

        var copyvalue = $(this).closest("tr").find("p").text();
        navigator.clipboard.writeText(copyvalue);

        // Maak de tooltip dynamisch aan
        $(this)
            .tooltip({
                placement: "top",
                title: "Gekopieerd!",
                trigger: "manual", // Voorkom dat de tooltip automatisch wordt getoond
            })
            .tooltip("show");

        // Verberg de tooltip na een bepaalde tijd (bijv. 2 seconden)
        setTimeout(function () {
            $(".copy-to-clipboard").tooltip("hide");
        }, 2000);

        return false;
    });

    // Functie om de tabelgegevens naar een Excel-bestand te exporteren
    function exportToExcel() {
        // Verkrijg de tabel met behulp van de juiste selecteur
        var table = $(".users.dashboard-results table");

        // Kloon de tabel en verwijder de laatste kolom ("Kopieer ID")
        var clonedTable = table.clone();
        clonedTable.find("tr").each(function () {
            $(this).find("td:last-child").remove();
        });

        // Verwijder de styling van de gekloonde tabel
        clonedTable.removeAttr("style");

        // Converteer de gekloonde tabelgegevens naar een werkmap
        var workbook = XLSX.utils.table_to_book(clonedTable[0]);

        // Converteer de werkmap naar een Excel-bestandsobject
        var excelFile = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        // Download het Excel-bestand
        var blob = new Blob([excelFile], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        var url = URL.createObjectURL(blob);
        var a = $("<a>", {
            href: url,
            download: "aangesloten-gebruikers.xlsx",
            style: "display: none",
        });
        $("body").append(a);
        a[0].click();
        a.remove();
    }

    // Voeg een klikgebeurtenis toe aan de knop met het id 'print-button'
    $("#print-button").on("click", function () {
        exportToExcel();
    });

    $(".close-notify").on("click", function () {
        $(".notify-form").removeClass("active");
    });

    // Voer de controle uit wanneer het formulier wordt ingediend
    $(".notify-form form").submit(function (e) {
        e.preventDefault(); // Voorkom standaardformulierindiening

        var gebruikersIDInput = $("#gebruikers_id");
        var gebruikersID = gebruikersIDInput.val();

        // Zoek alle gebruikers-ID's in de tabel
        var gebruikersIDs = $(".table-results .user-id");

        var gebruikersIDMatch = false;

        // Loop door de gebruikers-ID's in de tabel en controleer op overeenkomst
        gebruikersIDs.each(function () {
            var gebruikersIDInTabel = $(this).text().trim();

            if (gebruikersID === gebruikersIDInTabel) {
                gebruikersIDMatch = true;
                return false; // Break uit de each-lus
            }
        });

        if (gebruikersIDMatch) {
            // Het ingevoerde ID komt overeen, verstuur het formulier
            this.submit();
        } else {
            // Het ingevoerde ID komt niet overeen, toon een tooltip
            var tooltip = $("#gebruikers_id_tooltip");
            $("#gebruikers_id_tooltip").addClass("active");
        }
    });

    // Verberg de tooltip wanneer het gebruikers-ID-veld de focus krijgt
    $("#gebruikers_id").focus(function () {
        var tooltip = $("#gebruikers_id_tooltip");
        $("#gebruikers_id_tooltip").removeClass("active");
    });

    // $(".account-data .bottom-wrapper input,textarea").each(function (index) {
    //     $(this).prop("disabled", true);
    // });

    // $(".edit-information").on("click", function () {
    //     $(".account-data .bottom-wrapper input,textarea").each(function (
    //         index
    //     ) {
    //         $(this).prop("disabled", false);
    //     });
    // });

    // $(".account-data .form input,textarea,select").each(function (index) {
    //     $(this).prop("disabled", true);
    // });

    $("#account-sidebar-item").on("click", function () {
        $("#post-ready,#print-button,.search-bar").hide();

        $(".inner-wrapper .title h3").html("Accountgegevens");
    });

    $("#postadresses-sidebar-item").on("click", function () {
        $("#post-ready,#print-button,.search-bar").show();
        $(".inner-wrapper .title h3").html("Mijn postadressen");
    });

    $("#post-ready").on("click", function () {
        $(".notify-form").removeClass("active");
        $(".notify-form").addClass("active");
    });

    $(".hamburger").on("click", function () {
        $(".primary-menu-wrapper-dashboard").removeClass("active");
        $(".mobile-dashboard-menu").removeClass("active");
        $(".primary-menu-wrapper").toggleClass("active");
        $(".language-switch").toggleClass("active");
        $(this).toggleClass("active");
        $("body").toggleClass("active");
    });

    $(".mobile-dashboard-menu").on("click", function () {
        $(".hamburger").removeClass("active");
        $(".language-switch").removeClass("active");
        $(".primary-menu-wrapper").removeClass("active");
        $(".mobile-dashboard-menu").addClass("active");
        $(".primary-menu-wrapper-dashboard").toggleClass("active");


        $(this).toggleClass("active");
    });



    // if ($(window).width() < 1024) {
    //     $(".woocommerce-MyAccount-navigation").appendTo(
    //         ".primary-menu-wrapper-dashboard"
    //     );
    // } else {
    // }

    $(
        ".page-template-dashboard #wrapper-navbar .bottom-section .logo"
    ).prependTo(".top-section .container");

    $(".close").on("click", function () {
        $(this).parent().parent().removeClass("active");
    });

    $("#wrapper-navbar .dashboard").on("click", function () {
        $(this).toggleClass("active");
    });

    $(".gpnf-add-entry").addClass("button neutral");

    $(".postadres-field input").each(function () {
        var inputValue = $(this).val();
        if ($("#input_10_54").val().includes(inputValue)) {
            $(this).parent().hide();
        }
    });

    $("#gform_fields_10_3 .gfield-choice-input").on("click", function () {
        var value = $("#input_10_54").val();
        // console.log("1:", value);
        var checkboxValue = $(this).val();
        // console.log("2:", checkboxValue);
        $current_user_id = get_current_user_id();
        if ($(this).is(":checked")) {
            // console.log("ischecked");
            if (!value.includes(checkboxValue)) {
                value += `,${checkboxValue}`;
                // console.log("3:", value);
            }
        } else {
            value = value.replace(`,${checkboxValue}`, "");
        }
        // console.log("4:", value);
        $("#input_10_54").val(value);
    });

    jQuery(function ($) {
        $("#mediabirds_file").change(function () {
            if (!this.files.length) {
                $("#mediabirds_filelist").empty();
            } else {
                // we need only the only one for now, right?
                const file = this.files[0];

                $("#mediabirds_filelist").html(
                    '<img src="' +
                        URL.createObjectURL(file) +
                        '"><span>' +
                        file.name +
                        "</span>"
                );

                const formData = new FormData();
                formData.append("mediabirds_file", file);

                $.ajax({
                    url:
                        wc_checkout_params.ajax_url +
                        "?action=mediabirdsupload",
                    type: "POST",
                    data: formData,
                    contentType: false,
                    enctype: "multipart/form-data",
                    processData: false,
                    success: function (response) {
                        $('input[name="mediabirds_file_field"]').val(response);
                    },
                });
            }
        });
    });

    document.addEventListener("DOMContentLoaded", function () {
        var fileInput = document.getElementById("mediabirds_file");

        document
            .querySelector("form")
            .addEventListener("submit", function (event) {
                if (fileInput.value === "") {
                    $("#mediabirds_file").addClass("required");
                    event.preventDefault();
                } else {
                    $("#mediabirds_file").removeClass("required");
                }
            });
    });
})(jQuery);

jQuery(document).ready(function ($) {
    // Vang het wijzigen van de status van de aangepaste checkbox
    $(".custom-control-input").change(function () {
        var isChecked = $(this).prop("checked");

        // Als de checkbox is aangevinkt
        if (isChecked) {
            // Activeer de gewenste opties in de aangepaste select-box
            $("select#billing_custom_type").val("ondernemer");
            $('select#billing_custom_type option[value="particulier"]').prop(
                "disabled",
                true
            );
        } else {
            // Schakel de gewenste opties uit in de aangepaste select-box
            $('select#billing_custom_type option[value="particulier"]').prop(
                "disabled",
                false
            );
        }
    });
});

jQuery(function ($) {
    // Plus en min knoppen functionaliteit
    $(document).on("click", ".plus, .minus", function (e) {
        e.preventDefault();

        var $qty = $(this).closest(".quantity").find(".qty"),
            currentVal = parseFloat($qty.val()),
            max = parseFloat($qty.attr("max")),
            min = parseFloat($qty.attr("min")),
            step = $qty.attr("step");

        if (!currentVal || currentVal === "" || currentVal === "NaN")
            currentVal = 0;

        if (max === "" || max === "NaN") max = "";
        if (min === "" || min === "NaN") min = 0;
        if (
            step === "any" ||
            step === "" ||
            step === undefined ||
            parseFloat(step) === "NaN"
        )
            step = 1;

        if ($(this).hasClass("plus")) {
            if (max && (max == currentVal || currentVal > max)) {
                $qty.val(max);
            } else {
                $qty.val(currentVal + parseFloat(step));
            }
        } else {
            if (min && (min == currentVal || currentVal < min)) {
                $qty.val(min);
            } else if (currentVal > 0) {
                $qty.val(currentVal - parseFloat(step));
            }
        }

        // Dynamisch de href-waarde van de knop "Toevoegen aan winkelwagen" aanpassen
        var quantity = $qty.val();
        var updatedUrl = "?add-to-cart=666" + "&quantity=" + quantity;
        $(".product-add-to-cart").attr("href", updatedUrl);
    });

    $(
        ".woocommerce-edit-address .woocommerce-address-fields__field-wrapper #billing_custom_type"
    ).prop("disabled", true);

    $(
        ".woocommerce-edit-address .woocommerce-address-fields__field-wrapper #billing_last_name"
    ).prop("disabled", true);

    $(".woocommerce-NoticeGroup-checkout").remove();

    jQuery(document).ready(function ($) {
        // Voeg tooltips toe aan inputvelden met de class "tooltip"
        $(".___tooltip")
            .hover(
                function () {
                    var tooltipText = $("#mediabirds_file").data("tooltip");
                    $('<div class="custom-tooltip"></div>')
                        .text(tooltipText)
                        .appendTo(".___tooltip")
                        .fadeIn("fast");
                },
                function () {
                    $(".custom-tooltip").remove();
                }
            )

            .mousemove(function (e) {
                var mouseX = e.pageX + 10; // Offset om de tooltip naast de muis te plaatsen
                var mouseY = e.pageY + 10; // Offset om de tooltip onder de muis te plaatsen
                $(".custom-tooltip").css({
                    position: "absolute",
                });
            });
    });
});
